import type { FaireProductEntity } from "../../entity_types/product";

export const p_bqeo4l7l: FaireProductEntity = {
  token: "p_bqeo4l7l",
  type: "product",
  name: "Big Cake Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/9dcc23992ff42ed6a79d9586d82c952d04a4b099dc382dc5a84d8eca19933134.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c8a6c8caacd411899472c1074b60eb7fc95dd70a111d7946fe52b26331adc759.png",
    "https://cdn.faire.com/fastly/234774bb49bb653e702b32fe61ea7950dc73b97eb95305a5d87d8529b2f68002.png",
    "https://cdn.faire.com/fastly/74ab1cd9106044f417b52f0e044809290a67c60ba1caf2733f3d7dce8df65fb0.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:28.519Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
